import React from "react";
import ShoppingBagIconImg from "./images/shopping-bag.svg";

interface ShoppingBagIconProps {
  onClick?: () => void;
  itemCount?: number;
}

const ShoppingBagIcon: React.FunctionComponent<ShoppingBagIconProps> = ({ onClick, itemCount = 0 }) => {
  const containerStyle: React.CSSProperties = {
    width: "44px",
    height: "44px",
    cursor: "pointer",
    transition: "opacity 0.3s ease-in-out",
    position: "relative", // wichtig für Badge-Positionierung
    display: "inline-block",
  };

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
  };

  const badgeStyle: React.CSSProperties = {
    position: "absolute",
    bottom: "-6px",
    right: "-6px",
    backgroundColor: "#77A04A",
    color: "#fff",
    borderRadius: "50%",
    padding: "2px 6px",
    fontSize: "20px",
    fontWeight: 300,
    fontFamily: "Avenir Next Codensed Regular",
    lineHeight: 1,
    minWidth: "20px",
    textAlign: "center",
  };

  return (
    <div
      onClick={onClick}
      style={containerStyle}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <img src={ShoppingBagIconImg} alt="Shopping Bag" style={imageStyle} />
      {itemCount > 0 && <div style={badgeStyle}>{itemCount}</div>}
    </div>
  );
};

export default ShoppingBagIcon;
